import { Link, useSearchParams } from 'react-router-dom'

const PLAN_LABEL: Record<string, string> = {
  starter: 'Starter, €49/mo',
  business: 'Business, €199/mo',
}

export function WelcomePage() {
  const [params] = useSearchParams()
  const plan = params.get('plan') ?? ''
  const label = PLAN_LABEL[plan]

  return (
    <main className="max-w-2xl mx-auto px-6 pt-20 pb-16 text-center">
      <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-signal/15 mb-6">
        <span className="text-signal text-2xl">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            aria-hidden
            role="presentation"
            style={{
              width: '1em',
              height: '1em',
              display: 'inline-block',
              verticalAlign: '-0.125em',
            }}
          >
            <path d="M20 6L9 17l-5-5" />
          </svg>
        </span>
      </div>
      <h1
        className="font-display text-3xl mb-4"
        style={{ fontWeight: 210, letterSpacing: '-0.03em' }}
      >
        {label ? "You're in." : 'Almost there'}
      </h1>
      <p className="text-[var(--text-secondary)] leading-relaxed mb-8">
        {label ? (
          <>
            Thanks for subscribing to <span className="text-[var(--text-primary)]">{label}</span>.
            Your keys are ready. We've emailed your API key and MCP setup link, and you can create
            more keys in the dashboard now.
          </>
        ) : (
          <>Pick a plan on the pricing page to get full lane coverage and your own API + MCP key.</>
        )}
      </p>
      <div className="flex items-center justify-center gap-4">
        <Link
          to="/mcp"
          className="bg-signal text-on-accent font-bold px-5 py-3 rounded-xl no-underline hover:opacity-90"
        >
          Set up the MCP server
        </Link>
        <Link
          to="/compare"
          className="border border-border text-[var(--text-primary)] px-5 py-3 rounded-xl no-underline hover:border-signal/50"
        >
          Compare lanes
        </Link>
      </div>
      <p className="text-xs text-[var(--text-muted)] mt-8">
        Need help? Email{' '}
        <a href="mailto:sales@navo24.com" className="text-signal no-underline">
          sales@navo24.com
        </a>
        .
      </p>
    </main>
  )
}
